import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './meeting.css'
import {message} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
//import 'moment/locale/ar';
import {SearchOutlined} from '@ant-design/icons';
import moment from 'moment'
let headers = [
  { label: "#", key: "id" },
  { label: "ClientName", key: "clientName" },
  { label: "ClientPhone", key: "clientPhone" },
  { label: "broker", key: "broker" },
  { label: "status", key: "status" },
  { label: "SalesName", key: "salesName" },
  { label: "SalesPhone", key: "salesPhone" },
  { label: "Date", key: "date" },
];
 
let csvData = [
  
];
class meeting extends React.Component {
  
  state={
    meetings:[],
    meetings2:[],
    csvData:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    collapsed: false,
    broker:this.props.location.state?this.props.location.state.broker:null,
    search:null,
    category:null,
    location:null,
    filterType:{},
    status:null,
    meetingsFile:null,
    value:'',
  }

  constructor(props){
    super(props)
    this.getMeetingsWithoutPagenation()
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getMeetings(1)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  getMeetings = (page,rest) =>{
    this.setState({loading:true})
    let url = `${BASE_END_POINT}meetings?page=${page}`
    let {search,broker} = this.state
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(broker){
      let str = '&broker='+ broker
      url += str
    }
    if(rest) url = `${BASE_END_POINT}meetings?page=${page}`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("meetings   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.clientName?item.clientName :'',
        item.clientPhone?item.clientPhone :'',
        item.broker?item.broker.fullname :'',
        item.status === "PENDING"?{type:'tag',value:allStrings.pending}:item.status === "ACCEPTED"?{type:'tag',value:allStrings.accepted}:{type:'tag',value:allStrings.rejected},
        item.salesName?item.salesName :'',
        item.salesPhone?item.salesPhone :'',
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        meetings:response.data.data,
        meetings2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getMeetingsWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}meetings/withoutPagenation/get`
    let {search,broker} = this.state
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(broker){
      let str = '&broker='+ broker
      url += str
    }
    if(rest) url = `${BASE_END_POINT}meetings/withoutPagenation/get`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("meetings   ",response.data)
        csvData= response.data.data.map(item => {
          return {
            ...{id:item.id},
            ...{clientName:item.clientName?item.clientName:''},
            ...{clientPhone:item.clientPhone?item.clientPhone:''},
            ...{broker:item.broker?item.broker.fullname:''},
            ...{status:item.status?item.status:''},
            ...{salesName:item.salesName?item.salesName:''},
            ...{salesPhone:item.salesPhone?item.salesPhone:''},
            ...{date:moment(item.createdAt).format('lll')},
          };
        });
        console.log(csvData)
        this.setState({csvData:csvData})
      
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }
  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}meetings/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("Row DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getMeetings(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }
  paginationButtons = () =>(
    <CardActions style={{dACCEPTEDlay: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getMeetings(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getMeetings(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getMeetings(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} 
        style={{color:`#E6B659 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getMeetings(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getMeetings(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )


  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('MEETINGS')) return <Redirect to='/Home' />

    return (
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
            enableEdit = {false}
            title={allStrings.meetings}
            icon='meeting_room'
            
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,status:null});this.getMeetings(1,true);this.getMeetingsWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"meetings.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img crossorigin="anonymous"alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink>
              </div>
              
            }
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass160':'hideClass'}>
                  <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12">
                      <div class="md-form">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.Search}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                  <Button style={{background: '#E6B659',color: '#fff',width: '100%',margin: '32px auto'}} 
                    onClick={()=>{this.getMeetings(1);this.getMeetingsWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                  </MDBRow>
                </div>
              </div>
            }
            data={this.state.meetings}
            data2={this.state.meetings2}
            tableColumns={["#",allStrings.clientName,allStrings.clientPhone,allStrings.broker,allStrings.status,allStrings.salesName,allStrings.salesPhone,allStrings.action]}loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/meetingInfo'
            actionIndex={8}
            />
            {this.paginationButtons()}
              
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    
    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDACCEPTEDatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDACCEPTEDatchToProps)(meeting)
);

